module.exports = {
      id: "user-square-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#user-square",
      toString: function () {
        return this.url;
      }
    }